import { MatchesPlayers } from '@/modules/league/new-components/types';

export const getTrophy = (player: MatchesPlayers): boolean | undefined => {
  const scoresTeam1 = [
    player?.Team_1_Game1Score || 0,
    player?.Team_1_Game2Score || 0,
    player?.Team_1_Game3Score || 0,
    player?.Team_1_Game4Score || 0,
    player?.Team_1_Game5Score || 0,
  ];

  const scoresTeam2 = [
    player?.Team_2_Game1Score || 0,
    player?.Team_2_Game2Score || 0,
    player?.Team_2_Game3Score || 0,
    player?.Team_2_Game4Score || 0,
    player?.Team_2_Game5Score || 0,
  ];

  let gamesPlayed = 0;
  let winnerTeam1 = 0;
  let winnerTeam2 = 0;

  for (let i = 0; i < player.MaxGames; i++) {
    const score1 = scoresTeam1[i];
    const score2 = scoresTeam2[i];
    if (score1 !== undefined && score2 !== undefined && (score1 > 0 || score2 > 0)) {
      gamesPlayed++;
      if (score1 > score2) {
        winnerTeam1++;
      } else if (score2 > score1) {
        winnerTeam2++;
      }
    }
  }
  if (gamesPlayed < 3) {
    return winnerTeam1 === gamesPlayed || winnerTeam2 === gamesPlayed;
  } else {
    return true;
  }
};
